import { clsx } from 'clsx';
import { STATUS_CONFIG } from '../../utils/constants.js';

export default function StatusBadge({ status, className }) {
  const config = STATUS_CONFIG[status] || { label: status, badge: 'badge-draft' };
  return (
    <span className={clsx('badge', config.badge, className)}>
      {config.label}
    </span>
  );
}
